import React from 'react';

import Icon from '../../../ui/Icon';
import { useTranslation } from 'react-i18next';
import { getRecipientName } from '../../../ui/collections/Recipient';
import { Container, Name, FillSpace, StyledIcon, RemoveButton } from './Styles';

function RecipientNameChip({ style, compact, onClick, onRemove, item }) {
  const { t } = useTranslation(['commonPlat']);
  const [name, allowHide] = getRecipientName(item, t);
  return (
    <Container style={style} $compact={compact} onClick={onClick}>
      <FillSpace>
        <Name title={name}>{name}</Name>
      </FillSpace>
      {onRemove && (
        <RemoveButton
          type="button"
          onClick={onRemove}
          aria-label={t('commonPlat:labels.removeX', { name })}
          tabIndex={0}
        >
          <Icon name={'cross'} />
        </RemoveButton>
      )}
    </Container>
  );
}

export default RecipientNameChip;
